module.exports = __webpack_public_path__ + "img/curve_line_icon.f6cca4f4.svg";